import { HTMLAttributes, ReactNode, forwardRef } from 'react';

type ContainerMaxWidth = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;

export interface ContainerProps extends Omit<HTMLAttributes<HTMLDivElement>, 'color'> {
  children?: ReactNode;
  maxWidth?: ContainerMaxWidth;
  disableGutters?: boolean;
  fixed?: boolean;
}

const maxWidthClassName: Record<Exclude<ContainerMaxWidth, false>, string> = {
  xs: 'max-w-[444px]',
  sm: 'max-w-[600px]',
  md: 'max-w-[900px]',
  lg: 'max-w-[1200px]',
  xl: 'max-w-[1536px]',
};

export const Container = forwardRef<HTMLDivElement, ContainerProps>(function Container(
  { children, maxWidth = 'lg', disableGutters = false, fixed: _fixed, className, ...props },
  ref,
) {
  void _fixed;

  return (
    <div
      {...props}
      ref={ref}
      className={[
        'box-border mx-auto w-full',
        maxWidth === false ? '' : maxWidthClassName[maxWidth],
        disableGutters ? '' : 'px-4 sm:px-6',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
});
